import { render, staticRenderFns } from "./CreateAppointmentClient.vue?vue&type=template&id=c50cbe2a&scoped=true"
import script from "./CreateAppointmentClient.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentClient.vue?vue&type=script&lang=js"
import style0 from "./CreateAppointmentClient.vue?vue&type=style&index=0&id=c50cbe2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50cbe2a",
  null
  
)

export default component.exports